export default __webpack_public_path__ + "static/media/shtyxydm.709bcb0a.jpg";